import { ModalWindow, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { EType } from 'shared/types/villagePromotions';

import { Footer } from './inner/Footer';
interface IPromoDescriptionModalProps {
  name: string;
  open: boolean;
  subtitle?: string;
  description?: string | null;
  promoType: EType;
  builderName?: string | null;
  logoUrl?: string | null;
  phoneNumber?: string;
  onClose(): void;
  handleOpenContactModal(): void;
}

export const PromoDescriptionModal = (props: IPromoDescriptionModalProps) => {
  return (
    <ModalWindow
      open={props.open}
      content={props.description && <UIText1>{props.description}</UIText1>}
      escape
      fixed={false}
      footer={
        <Footer
          authorLabel="Акция от застройщика"
          authorName={props.builderName}
          authorLogoUrl={props.logoUrl}
          isDescriptionModal
          handleOpenContactModal={props.handleOpenContactModal}
        />
      }
      header={props.subtitle && <UIText2 color="gray60_100">{props.subtitle}</UIText2>}
      maxWidth={728}
      onClose={props.onClose}
      outside
      size="M"
      title={props.name}
    />
  );
};

PromoDescriptionModal.displayName = 'PromoDescriptionModal';
